export default __webpack_public_path__ + "static/media/search.b00b7833.svg";